import React from 'react';
import { Box } from 'edenred-ui';
import { Trans, useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { SuccessPageGraphic } from '@epi-pages/Onboarding/components/SuccessPageContent/SuccessPageContent.style';
import OnboardingSuccessPageImg from '@epi-assets/images/OnboardingSuccessPageGraphic.jpg';

export const SuccessPageContent = () => {
  const { t } = useTranslation();
  const { sizeExtraExtraLarge, fontSemiBold, gray10 } = useTheme();

  return (
    <Box>
      <Box border="1px solid" borderColor={gray10} display="flex" p={5} gap={5}>
        <Box width="55%">
          <Box fontSize={sizeExtraExtraLarge} fontWeight={fontSemiBold}>
            {t('components.onboarding.success_page.subtitle')}
          </Box>
          <Trans
            i18nKey={t('components.onboarding.success_page.description')}
          />
        </Box>
        <Box width="45%">
          <SuccessPageGraphic
            src={OnboardingSuccessPageImg}
            alt={t('components.onboarding.success_page.image_alt')}
          />
        </Box>
      </Box>
    </Box>
  );
};
